import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { MOCK_LANDING } from '@shared/mocks/landing.mock';

import { LandingOverview, RemoveFeaturedDto, UpdateFeaturedDto } from './interfaces/landing.interfaces';

import { HttpInterceptor } from '@interceptors/http/http.interceptor';

@Injectable({
  providedIn: 'root',
})
export class LandingService {
  private http = inject(HttpInterceptor);

  public overview(): Observable<LandingOverview> {
    return this.http.get('landing/featured', MOCK_LANDING);
  }

  public updateFeatured(dto: UpdateFeaturedDto): Observable<void> {
    return this.http.patch('landing/featured', dto, null);
  }

  public removeFeatured(dto: RemoveFeaturedDto): Observable<void> {
    return this.http.deleteWithBody('landing/featured', null, dto);
  }
}
